import React, { Component } from "react";
// import DatePicker from 'react-datepicker2';
import { Button, Image } from "react-bootstrap";
import exportall from "../assets/exportall.png";
// import portfolioicon from '../assets/portfolioicon.png'
import { MagicSpinner, ImpulseSpinner } from "react-spinners-kit";
import profiticon from "../assets/profiticon.png";
import moment from "moment-jalaali";
import NumberFormat from "react-number-format";
// import {
//   Chart as LineChart,
//   CommonSeriesSettings,
//   ArgumentAxis,
//   Grid,
//   Crosshair,
//   Point,
//   Tooltip,
//   CommonAxisSettings,
//   CommonAnnotationSettings,
//   HoverStyle,
// } from 'devextreme-react/chart';
// import {Series,Label,Font,Legend} from 'devextreme-react/pie-chart';
import {
  Chart,
  Legend,
  Label,
  Format,
  CommonSeriesSettings,
  Font,
  SeriesTemplate,
  ArgumentAxis,
  Tooltip,
  Crosshair,
  CommonAxisSettings,
} from "devextreme-react/chart";
import { Typeahead } from "react-bootstrap-typeahead";

import ContextMenuComponent from "../components/ContextMenuComponent";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import wrr from "../assets/wrr.png";
import "react-bootstrap-typeahead/css/Typeahead.css";

// import AnimatedNumber from "animated-number-react";

// import AnimatedNumber from 'react-animated-number';

import DatePicker, { DateObject } from "react-multi-date-picker";
// import Toolbar from "react-multi-date-picker/plugins/toolbar"
import "react-multi-date-picker/styles/layouts/mobile.css";
import "react-multi-date-picker/styles/layouts/prime.css";
import "react-multi-date-picker/styles/colors/bluee.css";

export default class Profit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentReportType: "last",
      dateValue: moment().format("jYYYY/jMM/jDD"),
      dateValue1: moment().add(-1, "months").format("jYYYY/jMM/jDD"),
      maxDate: moment().add(0, "days").format("jYYYY/jMM/jDD"),
      maxDateStart: moment().add(-1, "days").format("jYYYY/jMM/jDD"),
      minDate: moment().add(-1, "months").add(1, "day").format("jYYYY/jMM/jDD"),
      chartData: [],
      removeFilter: false,
      multiSelections: [],
      setMultiSelections: [],
      twrrCashFlow: null,
      mwrrCashFlow: null,
      twrrValue1: null,
      twrrValue2: null,
      twrrValue3: null,
      twrrValue4: null,
      mwrrValue1: null,
      mwrrValue2: null,
      mwrrValue3: null,
      mwrrValue4: null,
      fetchCancel: false,
      bvt: 0,
      evt: 0,
      twrrBVT: 0,
      mwrrEVT: 0,
      testNumber: 0,
      energySources: [
        { value: "portfolioNAV", name: "ارزش کل پرتفوی" },
        { value: "cash_sum", name: "نقدینگی" },
        { value: "total", name: "مجموع دارایی" },
      ],
    };

    this.reportTypeSwitch = React.createRef();
    this.conmenu = React.createRef();
    this.conmenu1 = React.createRef();
    this.conmenu2 = React.createRef();
    this.chartRef = React.createRef();

    this.datepickerr1 = React.createRef();
    this.datepickerr = React.createRef();

    this.Twrr = this.Twrr.bind(this);
    this.Mwrr = this.Mwrr.bind(this);

    this.controller = new AbortController();
  }

  componentDidMount() {
    this.props.pageIsopen();
    // this.chartFileterByDate()
    this.Twrr();
  }

  // componentDidUpdate(prevProps){
  //     if (prevProps.pageWidth!==this.props.pageWidth){
  //         this.chartRef.current.instance.render();
  //         // alert(1)
  //     }
  // }

  convertDate(date) {
    let timee = new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).formatToParts(date);
    let year = "";
    let month = "";
    let day = "";
    timee.forEach((element) => {
      if (element.type === "year") {
        year = element.value;
      } else if (element.type === "month") {
        month = element.value;
      } else if (element.type === "day") {
        day = element.value;
      }
    });
    let formatedDate = year + "/" + month + "/" + day;
    let pdate = moment(formatedDate, "YYYY/MM/DD").format("jYYYY-jMM-jDD");
    return pdate;
  }

  Twrr() {
    // let date1=this.convertDate(this.state.dateValue1);
    // let date2=this.convertDate(this.state.dateValue);

    // let date11=this.state.dateValue1.format('jYYYY/jM/jD')
    // let date22=moment().add(-1,'months').format('jYYYY/jM/jD')
    // let date33=this.state.dateValue.format('jYYYY/jM/jD')
    // let date44=moment().format('jYYYY/jM/jD')

    let date1 = moment(this.state.dateValue1, "jYYYY/jMM/jDD").format(
      "jYYYY-jMM-jDD"
    );
    let date2 = moment(this.state.dateValue, "jYYYY/jMM/jDD").format(
      "jYYYY-jMM-jDD"
    );

    let date11 = this.state.dateValue1;
    let date22 = moment().add(-1, "months").format("jYYYY/jMM/jDD");
    let date33 = this.state.dateValue;
    let date44 = moment().format("jYYYY/jMM/jDD");

    if (date11 !== date22 || date33 !== date44) {
      this.setState({ removeFilter: true });
    } else {
      this.setState({ removeFilter: false });
    }

    let basketids = [];
    let mode = null;
    if (this.props.tabselectedindex !== 0) {
      basketids.push(this.props.portfolioID);
    } else {
      if (this.state.multiSelections.length > 0) {
        this.state.multiSelections.forEach((element) => {
          basketids.push(element.id);
        });
      } else {
        mode = "total";
      }
    }
    let data = {
      mobile: localStorage.getItem("mobile"),
      token: localStorage.getItem("token"),
      basket_id: basketids,
      type: "last",
      mode: mode,
      start_date: date1.toString(),
      end_date: date2.toString(),
    };

    this.controller = new AbortController();
    var signal = this.controller.signal;

    this.setState(
      {
        isLoading: true,
        chartData: [],
        twrrCashFlow: [],
        twrrValue1: 0,
        twrrValue2: 0,
        twrrValue3: 0,
        twrrValue4: 0,
        twrrBVT: 0,
        twrrEVT: 0,
        mwrrCashFlow: [],
        mwrrValue1: 0,
        mwrrValue2: 0,
        mwrrValue3: 0,
        mwrrValue4: 0,
        mwrrBVT: 0,
        mwrrEVT: 0,
        bvt: 0,
        evt: 0,
      },
      () => {
        fetch("/api/getTwrr", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
          signal,
        })
          .then((res) => res.json())
          .then((resultt) => {
            // console.log(resultt);
            if (resultt.status === 200) {
              let tempCashflow = resultt.result.cashFlow;
              tempCashflow[0].bvt = resultt.result.BVT;
              tempCashflow[resultt.result.cashFlow.length - 1].evt =
                resultt.result.EVT;
              // alert(Number(resultt.result.totalProfit))
              this.setState(
                {
                  twrrCashFlow: tempCashflow,
                  twrrValue1: Number(resultt.result.TWRR),
                  twrrValue2: Number(resultt.result.totalProfit),
                  twrrValue3:
                    this.props.tabselectedindex !== 0
                      ? Number(
                          (this.props.selectedPortfolioPercent / 100) *
                            resultt.result.totalProfit
                        )
                      : "-",
                  twrrValue4:
                    this.props.tabselectedindex !== 0
                      ? Number(
                          resultt.result.totalProfit -
                            (this.props.selectedPortfolioPercent / 100) *
                              resultt.result.totalProfit
                        )
                      : "-",
                  twrrBVT: resultt.result.BVT,
                  twrrEVT: resultt.result.EVT,
                },
                () => {
                  this.Mwrr(signal);
                }
              );
            } else {
            }
          })
          .catch((err) => {
            if (this.state.fetchCancel) {
              this.setState({ fetchCancel: false }, () => {
                this.Twrr();
              });
            } else {
              this.setState({ isLoading: false });
            }
          });
      }
    );
  }

  Mwrr(signal) {
    // let date1=this.convertDate(this.state.dateValue1);
    // let date2=this.convertDate(this.state.dateValue);
    let date1 = moment(this.state.dateValue1, "jYYYY/jMM/jDD").format(
      "jYYYY-jMM-jDD"
    );
    let date2 = moment(this.state.dateValue, "jYYYY/jMM/jDD").format(
      "jYYYY-jMM-jDD"
    );
    let basketids = [];
    let mode = null;
    if (this.props.tabselectedindex !== 0) {
      basketids.push(this.props.portfolioID);
    } else {
      if (this.state.multiSelections.length > 0) {
        this.state.multiSelections.forEach((element) => {
          basketids.push(element.id);
        });
      } else {
        mode = "total";
      }
    }
    let data = {
      mobile: localStorage.getItem("mobile"),
      token: localStorage.getItem("token"),
      basket_id: basketids,
      type: "last",
      mode: mode,
      start_date: date1.toString(),
      end_date: date2.toString(),
    };
    fetch("/api/getMwrr", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
      signal,
    })
      .then((res) => res.json())
      .then((resultt) => {
        // console.log(resultt);
        if (resultt.status === 200) {
          // alert(resultt.result.MWRR.toString())
          this.setState(
            {
              mwrrCashFlow: resultt.result.cashFlow,
              mwrrValue1: Number(resultt.result.MWRR),
              mwrrValue2: Number(resultt.result.totalProfit),
              mwrrValue3:
                this.props.tabselectedindex !== 0
                  ? Number(
                      (this.props.selectedPortfolioPercent / 100) *
                        resultt.result.totalProfit
                    )
                  : "-",
              mwrrValue4:
                this.props.tabselectedindex !== 0
                  ? Number(
                      resultt.result.totalProfit -
                        (this.props.selectedPortfolioPercent / 100) *
                          resultt.result.totalProfit
                    )
                  : "-",
              mwrrBVT: resultt.result.BVT,
              mwrrEVT: resultt.result.EVT,
            },
            () => {
              if (this.props.tabselectedindex === 0) {
                let temp = this.state.twrrCashFlow;
                if (temp.length > 0) {
                  if (temp[0].cash_change === 0) temp.splice(0, 1);
                  if (temp[temp.length - 1].cash_change === 0)
                    temp.splice(temp.length - 1, 1);
                  temp.unshift({
                    tr_date: "BV (" + date1.toString() + ")",
                    cash_change: this.state.twrrBVT,
                  });
                  temp.push({
                    tr_date: "EV (" + date2.toString() + ")",
                    cash_change: this.state.twrrEVT,
                  });
                }

                this.setState({ twrrCashFlow: temp }, () => {
                  this.setState({
                    chartData: this.state.twrrCashFlow,
                    bvt: this.state.twrrBVT
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                    evt: this.state.twrrEVT
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                  });
                });
              } else {
                let temp = this.state.mwrrCashFlow;
                if (temp.length > 0) {
                  if (temp[0].cash_change === 0) temp.splice(0, 1);
                  if (temp[temp.length - 1].cash_change === 0)
                    temp.splice(temp.length - 1, 1);
                  // temp.unshift({tr_date:'BV ('+date1.toString()+')',cash_change:this.state.mwrrBVT});
                  // temp.push({tr_date:'EV ('+date2.toString()+')',cash_change:this.state.mwrrEVT})
                }

                temp.unshift({
                  tr_date: "BV (" + date1.toString() + ")",
                  cash_change: this.state.mwrrBVT,
                });
                temp.push({
                  tr_date: "EV (" + date2.toString() + ")",
                  cash_change: this.state.mwrrEVT,
                });

                this.setState({ mwrrCashFlow: temp }, () => {
                  this.setState({
                    chartData: this.state.mwrrCashFlow,
                    bvt: this.state.mwrrBVT
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                    evt: this.state.mwrrEVT
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                  });
                });
              }
            }
          );
        } else {
        }
        this.setState({ isLoading: false });
      })
      .catch((err) => {
        if (this.state.fetchCancel) {
          this.setState({ fetchCancel: false }, () => {
            this.Twrr();
          });
        } else {
          this.setState({ isLoading: false });
        }
      });
  }

  fixNumber(str) {
    var persianNumbers = [
        /۰/g,
        /۱/g,
        /۲/g,
        /۳/g,
        /۴/g,
        /۵/g,
        /۶/g,
        /۷/g,
        /۸/g,
        /۹/g,
      ],
      arabicNumbers = [
        /٠/g,
        /١/g,
        /٢/g,
        /٣/g,
        /٤/g,
        /٥/g,
        /٦/g,
        /٧/g,
        /٨/g,
        /٩/g,
      ];
    if (typeof str === "string") {
      for (var i = 0; i < 10; i++) {
        str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
      }
    }
    return str;
  }

  dateChange1(dateValue) {
    // this.setState({ dateValue1: dateValue,minDate:moment(dateValue).add(0,'days')})

    try {
      this.datepickerr.current.closeCalendar();
      this.datepickerr1.current.closeCalendar();
    } catch (error) {}
    let value = this.fixNumber(new DateObject(dateValue).format("YYYY/MM/DD"));
    // let min=this.fixNumber(new DateObject(dateValue).format('YYYY/MM/DD'));
    let min = this.fixNumber(
      new DateObject(dateValue).add(1, "days").format("YYYY/MM/DD")
    );
    this.setState({ dateValue1: value, minDate: min });
  }

  dateChange(dateValue) {
    // this.setState({ dateValue: dateValue,maxDateStart:moment(dateValue).add(-1,'days')})

    try {
      this.datepickerr.current.closeCalendar();
      this.datepickerr1.current.closeCalendar();
    } catch (error) {}
    let value = this.fixNumber(new DateObject(dateValue).format("YYYY/MM/DD"));

    // console.log(value);
    this.setState({
      dateValue: value,
      maxDateStart: this.fixNumber(
        new DateObject(dateValue).add(-1, "day").format("YYYY/MM/DD")
      ),
    });
  }

  removeFilter() {
    this.setState(
      {
        dateValue: moment().format("jYYYY/jMM/jDD"),
        dateValue1: moment().add(-1, "months").format("jYYYY/jMM/jDD"),
        maxDate: moment().add(0, "days").format("jYYYY/jMM/jDD"),
        maxDateStart: moment().add(-1, "days").format("jYYYY/jMM/jDD"),
        fetchCancel: true,
      },
      () => {
        if (this.state.isLoading) {
          this.controller.abort();
        } else {
          this.Twrr();
        }

        this.setState({ removeFilter: false });
      }
    );
  }

  btnClick() {
    this.conmenu.current.showMenu(
      this.targett.getBoundingClientRect().bottom + "px",
      this.targett.getBoundingClientRect().left + "px"
    );
  }

  menuClicked(target) {
    this.props.twrrMessage();
  }

  btnClick1() {
    this.conmenu1.current.showMenu(
      this.targett1.getBoundingClientRect().bottom + "px",
      this.targett1.getBoundingClientRect().left + "px"
    );
  }

  menuClicked1(target) {
    this.props.mwrrMessage();
  }

  searchSymbol() {}

  acSymbolChange() {}

  onBasketChange(event) {
    // console.log(event);
    this.setState({ multiSelections: event });
  }

  menuClicked2(target) {
    if (!this.state.isLoading) {
      switch (target) {
        case "PNG": {
          this.chartRef.current.instance.exportTo(
            "chart_" + Date.now().toString(),
            "PNG"
          );
          break;
        }
        case "JPG": {
          this.chartRef.current.instance.exportTo(
            "chart_" + Date.now().toString(),
            "JPG"
          );
          break;
        }
        case "SVG": {
          this.chartRef.current.instance.exportTo(
            "chart_" + Date.now().toString(),
            "SVG"
          );
          break;
        }
        case "PDF": {
          this.chartRef.current.instance.exportTo(
            "chart_" + Date.now().toString(),
            "PDF"
          );
          break;
        }
        case "GIF": {
          this.chartRef.current.instance.exportTo(
            "chart_" + Date.now().toString(),
            "GIF"
          );
          break;
        }
        default: {
          this.chartRef.current.instance.exportTo(
            "chart_" + Date.now().toString(),
            "PNG"
          );
          break;
        }
      }
    }
  }

  btnClick2() {
    this.conmenu2.current.showMenu(
      this.targett2.getBoundingClientRect().bottom + "px",
      this.targett2.getBoundingClientRect().left + "px"
    );
  }

  customizeSeries(cash_change) {
    return cash_change < 0
      ? { color: "var(--red1)" }
      : { color: "var(--green1)" };
  }

  // customizeSeries1(tr_date){
  //     return tr_date === 'EV' ? { color: "black" } : { };
  // }

  render() {
    return (
      <div
        ref={this.tabcontainer}
        className={
          this.props.tabselectedindex === 0
            ? "tabsContainer rmvStartRadius"
            : "tabsContainer"
        }
      >
        <div className="tabsAllContent">
          <div ref={this.tabcontent} className="tabsContentProfit">
            {this.props.pageWidth >= 1200 && (
              <div ref={this.container} className="tabsContentHeader">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    alignSelf: "flex-start",
                    fontSize: "12px",
                    color: "var(--gray4)",
                    minHeight: "32px",
                  }}
                >
                  <img
                    src={profiticon}
                    style={{ height: "20px", marginLeft: "10px" }}
                    alt="profit"
                  />
                  <div>نمودار جریان وجوه نقدی</div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row-reverse",
                    alignItems: "center",
                    flexWrap: "wrap",
                    flex: "1",
                  }}
                >
                  <Button
                    variant="secondary"
                    id="targett2"
                    ref={(scope) => (this.targett2 = scope)}
                    className="filterButton"
                    onClick={this.btnClick2.bind(this)}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row-reverse",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ flexDirection: "row", display: "flex" }}>
                        <div style={{ marginLeft: "10px", height: "100%" }}>
                          فایل خروجی
                        </div>
                        <Image style={{ height: "16px" }} src={exportall} />
                      </div>
                    </div>
                  </Button>
                  <div
                    style={{
                      flexWrap: "wrap",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      fontSize: "12px",
                    }}
                  >
                    <div
                      style={{
                        margin: "0px 10px",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ margin: "0px 5px", whiteSpace: "nowrap" }}>
                        شروع بازه:
                      </div>
                      {/* <DatePicker
                                            max={this.state.maxDateStart}
                                            className="form-control inputStyleFilter"
                                            timePicker={false}
                                            isGregorian={false}
                                            ref={(scope) => this.datepickerr1 = scope}
                                            onChange={valuee => this.dateChange1(valuee)}
                                            value={this.state.dateValue1}/> */}
                      <DatePicker
                        ref={this.datepickerr1}
                        value={this.state.dateValue1}
                        inputClass="form-control inputStyleFilter"
                        calendar="persian"
                        locale="fa"
                        weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
                        format="YYYY/MM/DD"
                        animation
                        className="bluee"
                        onChange={(valuee) => this.dateChange1(valuee)}
                        maxDate={this.state.maxDateStart}
                        editable={false}
                        inputMode="none"
                        placeholder="شروع"
                      />
                    </div>

                    <div
                      style={{
                        margin: "0px 10px",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ margin: "0px 5px", whiteSpace: "nowrap" }}>
                        پایان بازه:
                      </div>
                      {/* <DatePicker
                                            min={this.state.minDate}
                                            max={this.state.maxDate}
                                            className="form-control inputStyleFilter"
                                            timePicker={false}
                                            isGregorian={false}
                                            ref={(scope) => this.datepickerr = scope}
                                            onChange={valuee => this.dateChange(valuee)}
                                            value={this.state.dateValue}
                                        /> */}

                      <DatePicker
                        ref={this.datepickerr}
                        value={this.state.dateValue}
                        inputClass="form-control inputStyleFilter"
                        calendar="persian"
                        locale="fa"
                        weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
                        format="YYYY/MM/DD"
                        animation
                        className="bluee"
                        onChange={(valuee) => this.dateChange(valuee)}
                        minDate={this.state.minDate}
                        maxDate={this.state.maxDate}
                        editable={false}
                        inputMode="none"
                        placeholder="پایان"
                      />
                    </div>
                    <Button
                      onClick={this.Twrr}
                      style={{
                        padding: "0px 10px",
                        fontSize: "10px",
                        marginLeft: "10px",
                        height: "32px",
                        whiteSpace: "nowrap",
                        color: "white",
                      }}
                    >
                      اعمال فیلتر
                    </Button>
                    {this.state.removeFilter && (
                      <Button
                        variant="danger"
                        onClick={this.removeFilter.bind(this)}
                        style={{
                          padding: "0px 10px",
                          fontSize: "10px",
                          marginLeft: "10px",
                          height: "32px",
                          whiteSpace: "nowrap",
                          color: "white",
                        }}
                      >
                        حذف فیلتر
                      </Button>
                    )}
                  </div>

                  <div
                    style={{ flex: "1", direction: "ltr", fontSize: "12px" }}
                  >
                    {this.props.tabselectedindex === 0 && (
                      <div className="filterMultiSelectContainer">
                        {/* <div style={{marginLeft:'5px',whiteSpace:'nowrap'}}>فیلتر بر اساس سبد:</div> */}
                        <Typeahead
                          variant="danger"
                          id="basic-typeahead-multiple"
                          labelKey="lable"
                          emptyLabel="موردی یافت نشد"
                          style={{ fontSize: "11px" }}
                          multiple
                          onChange={this.onBasketChange.bind(this)}
                          options={this.props.userBasketsData}
                          placeholder="انتخاب سبدها"
                          selected={this.state.multiSelections}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}

            {this.props.pageWidth < 1200 && (
              <div ref={this.container} className="tabsContentHeaderSmall">
                <div className="tabsContentHeaderChild1">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "var(--gray4)",
                    }}
                  >
                    <img
                      src={profiticon}
                      style={{ height: "20px", marginLeft: "10px" }}
                      alt="profit"
                    />
                    <div>نمودار جریان وجوه نقدی</div>
                  </div>
                  <Button
                    variant="secondary"
                    id="targett2"
                    ref={(scope) => (this.targett2 = scope)}
                    className="filterButton"
                    onClick={this.btnClick2.bind(this)}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row-reverse",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ flexDirection: "row", display: "flex" }}>
                        <Image style={{ height: "16px" }} src={exportall} />
                      </div>
                    </div>
                  </Button>
                </div>

                {this.props.pageWidth < 600 && (
                  <div
                    className="tabsContentHeaderChild2"
                    style={{
                      flexDirection: "row-reverse",
                      marginBottom: "5px",
                    }}
                  >
                    <div
                      style={{ flex: "1", direction: "ltr", fontSize: "12px" }}
                    >
                      {this.props.tabselectedindex === 0 && (
                        <div
                          className="filterMultiSelectContainer"
                          style={{ width: "100%" }}
                        >
                          {/* <div style={{marginLeft:'5px',whiteSpace:'nowrap'}}>فیلتر بر اساس سبد:</div> */}
                          <Typeahead
                            variant="danger"
                            id="basic-typeahead-multiple"
                            labelKey="lable"
                            emptyLabel="موردی یافت نشد"
                            style={{ fontSize: "11px" }}
                            multiple
                            onChange={this.onBasketChange.bind(this)}
                            options={this.props.userBasketsData}
                            placeholder="انتخاب سبدها"
                            selected={this.state.multiSelections}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                )}

                <div
                  className="tabsContentHeaderChild2"
                  style={{ flexDirection: "row-reverse" }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent:
                        this.props.pageWidth >= 600
                          ? "space-between"
                          : "flex-end",
                      width: "100%",
                    }}
                  >
                    {this.props.pageWidth >= 600 && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            flex: "1",
                            direction: "ltr",
                            fontSize: "10px",
                          }}
                        >
                          {this.props.tabselectedindex === 0 && (
                            <div
                              className="filterMultiSelectContainer"
                              style={{ margin: "0" }}
                            >
                              {/* <div style={{marginLeft:'3px',whiteSpace:'nowrap'}}>فیلتر بر اساس سبد:</div> */}
                              <Typeahead
                                variant="danger"
                                id="basic-typeahead-multiple"
                                labelKey="lable"
                                emptyLabel="موردی یافت نشد"
                                style={{ fontSize: "10px" }}
                                multiple
                                onChange={this.onBasketChange.bind(this)}
                                options={this.props.userBasketsData}
                                placeholder="انتخاب سبدها"
                                selected={this.state.multiSelections}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <div
                        style={{
                          margin: "0px",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            marginRight: "0px",
                            marginLeft: "3px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          شروع:
                        </div>
                        {/* <DatePicker
                                                max={this.state.maxDateStart}
                                                className="form-control inputStyleFilter"
                                                timePicker={false}
                                                isGregorian={false}
                                                ref={(scope) => this.datepickerr1 = scope}
                                                onChange={valuee => this.dateChange1(valuee)}
                                                value={this.state.dateValue1}/> */}
                        <DatePicker
                          ref={this.datepickerr1}
                          value={this.state.dateValue1}
                          inputClass="form-control inputStyleFilter"
                          calendar="persian"
                          locale="fa"
                          weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
                          format="YYYY/MM/DD"
                          animation
                          className="rmdp-mobile bluee"
                          onChange={(valuee) => this.dateChange1(valuee)}
                          maxDate={this.state.maxDateStart}
                          editable={false}
                          inputMode="none"
                          placeholder="شروع"
                        />
                      </div>

                      <div
                        style={{
                          margin: "0px 5px",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{ margin: "0px 3px", whiteSpace: "nowrap" }}
                        >
                          پایان:
                        </div>
                        {/* <DatePicker
                                                min={this.state.minDate}
                                                max={this.state.maxDate}
                                                className="form-control inputStyleFilter"
                                                timePicker={false}
                                                isGregorian={false}
                                                ref={(scope) => this.datepickerr = scope}
                                                onChange={valuee => this.dateChange(valuee)}
                                                value={this.state.dateValue}
                                            /> */}

                        <DatePicker
                          ref={this.datepickerr}
                          value={this.state.dateValue}
                          inputClass="form-control inputStyleFilter"
                          calendar="persian"
                          locale="fa"
                          weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
                          format="YYYY/MM/DD"
                          animation
                          className="rmdp-mobile bluee"
                          onChange={(valuee) => this.dateChange(valuee)}
                          minDate={this.state.minDate}
                          maxDate={this.state.maxDate}
                          editable={false}
                          inputMode="none"
                          placeholder="پایان"
                        />
                      </div>

                      <Button
                        onClick={this.Twrr}
                        style={{
                          padding: "0px 5px",
                          fontSize: "10px",
                          height: "32px",
                          whiteSpace: "nowrap",
                          color: "white",
                        }}
                      >
                        اعمال
                      </Button>
                      {this.state.removeFilter && (
                        <Button
                          variant="danger"
                          onClick={this.removeFilter.bind(this)}
                          style={{
                            padding: "0px 5px",
                            fontSize: "10px",
                            marginRight: "5px",
                            height: "32px",
                            whiteSpace: "nowrap",
                            color: "white",
                          }}
                        >
                          حذف فیلتر
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            <ContextMenuComponent
              data={[
                { title: "PNG", target: "PNG" },
                { title: "JPG", target: "JPG" },
                { title: "GIF", target: "GIF" },
                { title: "SVG", target: "SVG" },
                { title: "PDF", target: "PDF" },
              ]}
              isChart={true}
              targett={this.targett2}
              menuClicked={this.menuClicked2.bind(this)}
              ref={this.conmenu2}
            />

            {!this.state.isLoading && (
              <div className="profitChartContainer">
                <Chart
                  ref={this.chartRef}
                  dataSource={this.state.chartData}
                  className="myBarChart"
                >
                  <CommonSeriesSettings
                    barPadding={0.6}
                    argumentField="tr_date"
                    valueField="cash_change"
                    type="bar"
                    ignoreEmptyPoints={true}
                  >
                    <Label
                      visible={false}
                      wordWrap="none"
                      textOverflow="none"
                      textAlign="center"
                      overlappingBehavior="rotate"
                    >
                      <Format type="fixedPoint" precision={0} />
                      <Font
                        color="white"
                        family="IRANSansMobile(FaNum)"
                        size={10}
                      />
                    </Label>
                  </CommonSeriesSettings>
                  <Tooltip enabled={true} cornerRadius={7} format="fixedPoint">
                    <Font
                      color="black"
                      family="IRANSansMobile(FaNum)"
                      size={10}
                    />
                  </Tooltip>
                  <CommonAxisSettings>
                    <Label visible={true}>
                      <Font
                        color="var(--textcolor1)"
                        size={10}
                        family="IRANSansMobile(FaNum)"
                      />
                    </Label>
                  </CommonAxisSettings>
                  <ArgumentAxis>
                    <Label wordWrap="none" overlappingBehavior="rotate" />
                  </ArgumentAxis>
                  <Crosshair
                    enabled={true}
                    color="#949494"
                    width={3}
                    dashStyle="dot"
                  >
                    <Label visible={true} backgroundColor="#949494">
                      <Font
                        color="#fff"
                        size={12}
                        family="IRANSansMobile(FaNum)"
                      />
                    </Label>
                  </Crosshair>
                  <SeriesTemplate
                    nameField="cash_change"
                    customizeSeries={this.customizeSeries}
                  />
                  <Legend visible={false} />
                </Chart>
              </div>
            )}

            {this.state.isLoading && (
              <div className="loading-inside">
                <MagicSpinner size={70} color="var(--green1)" loading={true} />
                <div style={{ marginTop: "14px" }}>لطفاً شکیبا باشید</div>
              </div>
            )}
          </div>

          <div className="dashChartsProfit">
            <div className="chargBGProfit pieChartStyle">
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  direction: "rtl",
                }}
              >
                <div style={{ width: "100%", fontSize: "13px" }}>
                  <img
                    src={wrr}
                    style={{ height: "20px", marginLeft: "10px" }}
                    alt="TWRR"
                  />
                  TWRR
                </div>
                <div
                  className="transButton"
                  id="targett"
                  style={{ height: "20px" }}
                  ref={(scope) => (this.targett = scope)}
                  onClick={this.btnClick.bind(this)}
                >
                  <FontAwesomeIcon
                    className={
                      !this.props.selected
                        ? "transButtonContent"
                        : "transButtonContentSelected"
                    }
                    icon={faEllipsisV}
                  />
                </div>
              </div>
              <div className="profitDetailContainer">
                <div className="profitDetail">
                  <div>درصد بازده سبدگردان</div>
                  <div
                    style={{
                      flex: "1",
                      height: "1px",
                      backgroundColor: "var(--gray3)",
                      margin: "0px 20px",
                    }}
                  />
                  {!this.state.isLoading && (
                    <div
                      style={{ display: "flex", flexDirection: "row-reverse" }}
                    >
                      <div style={{ direction: "rtl", marginLeft: "5px" }}>
                        %
                      </div>
                      {/* <AnimatedNumber component="text" value={this.state.twrrValue1}
                                            duration={1000}
                                            formatValue={n => 
                                            {
                                                if (n>999)
                                                {return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                else return n
                                            }}
                                            stepPrecision={0}
                                            /> */}
                      {/* <AnimatedNumber
                                            value={this.state.twrrValue1}
                                            stepPrecision={2}
                                            formatValue={n => 
                                            {
                                                if (n>999)
                                                {return Number(n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")).toFixed(2) }
                                                else return Number(n).toFixed(2)
                                            }}
                                            /> */}
                      {/* <AnimatedNumber
                                                value={this.state.twrrValue1}
                                                stepPrecision={2}
                                                formatValue={n => 
                                                {
                                                    if (Number(n)>999)
                                                    {return Number(n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")) }
                                                    else return Number(n)
                                                }}
                                            /> */}
                      <NumberFormat
                        allowNegative={true}
                        value={this.state.twrrValue1}
                        displayType={"text"}
                        thousandSeparator={true}
                      />
                    </div>
                  )}
                  {this.state.isLoading && (
                    <ImpulseSpinner
                      size={30}
                      frontColor="var(--gray2)"
                      backColor="var(--gray3)"
                      loading={true}
                    />
                  )}
                </div>

                <div className="profitDetail">
                  <div>جمع بازده ریالی زیر دوره ها</div>
                  <div
                    style={{
                      flex: "1",
                      height: "1px",
                      backgroundColor: "var(--gray3)",
                      margin: "0px 20px",
                    }}
                  />
                  {!this.state.isLoading && (
                    <div
                      style={{ display: "flex", flexDirection: "row-reverse" }}
                    >
                      {/* <AnimatedNumber
                                            value={this.state.twrrValue2}
                                            stepPrecision={2}
                                            formatValue={n => 
                                            {
                                                //.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                                console.log(Number(n).toFixed(2));
                                                if (Number(n)>999)
                                                { return Number(n) }
                                                else return Number(n);
                                            }}
                                            /> */}
                      {/* <AnimatedNumber
                                                value={this.state.twrrValue2}
                                                stepPrecision={0}
                                                duration={1500}
                                                formatValue={n => 
                                                {
                                                    if (Number(n)>999)
                                                    {return Number(n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")) }
                                                    else return Number(n)
                                                }}
                                            /> */}
                      <NumberFormat
                        allowNegative={true}
                        value={this.state.twrrValue2}
                        displayType={"text"}
                        thousandSeparator={true}
                      />
                      <div style={{ direction: "rtl", marginRight: "5px" }}>
                        ریال
                      </div>
                    </div>
                  )}
                  {this.state.isLoading && (
                    <ImpulseSpinner
                      size={30}
                      frontColor="var(--gray2)"
                      backColor="var(--gray3)"
                      loading={true}
                    />
                  )}
                </div>

                <div className="profitDetail">
                  <div>سهم سبدگردان</div>
                  {this.props.tabselectedindex !== 0 && (
                    <div style={{ fontSize: "12px" }}>
                      ({this.props.selectedPortfolioPercent}%)&nbsp;
                    </div>
                  )}
                  <div
                    style={{
                      flex: "1",
                      height: "1px",
                      backgroundColor: "var(--gray3)",
                      margin: "0px 20px",
                    }}
                  />
                  {!this.state.isLoading && (
                    <div
                      style={{ display: "flex", flexDirection: "row-reverse" }}
                    >
                      {this.state.twrrValue3 !== "-" && (
                        <NumberFormat
                          allowNegative={true}
                          value={this.state.twrrValue3}
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      )}

                      {this.state.twrrValue3 === "-" && <div>-</div>}
                      {this.state.twrrValue3 !== "-" && (
                        <div style={{ direction: "rtl", marginRight: "5px" }}>
                          ریال
                        </div>
                      )}
                    </div>
                  )}
                  {this.state.isLoading && (
                    <ImpulseSpinner
                      size={30}
                      frontColor="var(--gray2)"
                      backColor="var(--gray3)"
                      loading={true}
                    />
                  )}
                </div>

                <div className="profitDetail">
                  <div>سهم سرمایه‌گذار</div>
                  {this.props.tabselectedindex !== 0 && (
                    <div style={{ fontSize: "12px" }}>
                      ({100 - this.props.selectedPortfolioPercent}%)&nbsp;
                    </div>
                  )}
                  <div
                    style={{
                      flex: "1",
                      height: "1px",
                      backgroundColor: "var(--gray3)",
                      margin: "0px 20px",
                    }}
                  />
                  {!this.state.isLoading && (
                    <div
                      style={{ display: "flex", flexDirection: "row-reverse" }}
                    >
                      {this.state.twrrValue4 !== "-" && (
                        <NumberFormat
                          allowNegative={true}
                          value={this.state.twrrValue4}
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      )}
                      {this.state.twrrValue4 === "-" && <div>-</div>}
                      {this.state.twrrValue4 !== "-" && (
                        <div style={{ direction: "rtl", marginRight: "5px" }}>
                          ریال
                        </div>
                      )}
                    </div>
                  )}
                  {this.state.isLoading && (
                    <ImpulseSpinner
                      size={30}
                      frontColor="var(--gray2)"
                      backColor="var(--gray3)"
                      loading={true}
                    />
                  )}
                </div>
              </div>

              <ContextMenuComponent
                data={[{ title: "توضیحات", target: "description" }]}
                isChart={true}
                targett={this.targett}
                menuClicked={this.menuClicked.bind(this)}
                ref={this.conmenu}
              />
            </div>

            <div className="chartBG pieChartStyle chargBGProfit">
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  direction: "rtl",
                }}
              >
                <div style={{ width: "100%", fontSize: "13px" }}>
                  <img
                    src={wrr}
                    style={{ height: "20px", marginLeft: "10px" }}
                    alt="MWRR"
                  />
                  MWRR
                </div>
                <div
                  className="transButton"
                  id="targett"
                  style={{ height: "20px" }}
                  ref={(scope) => (this.targett1 = scope)}
                  onClick={this.btnClick1.bind(this)}
                >
                  <FontAwesomeIcon
                    className={
                      !this.props.selected
                        ? "transButtonContent"
                        : "transButtonContentSelected"
                    }
                    icon={faEllipsisV}
                  />
                </div>
              </div>
              <div className="profitDetailContainer">
                <div className="profitDetail">
                  <div>سود درصدی</div>
                  <div
                    style={{
                      flex: "1",
                      height: "1px",
                      backgroundColor: "var(--gray3)",
                      margin: "0px 20px",
                    }}
                  />
                  {!this.state.isLoading && (
                    <div
                      style={{ display: "flex", flexDirection: "row-reverse" }}
                    >
                      <div style={{ direction: "rtl", marginLeft: "5px" }}>
                        %
                      </div>
                      <NumberFormat
                        allowNegative={true}
                        value={this.state.mwrrValue1}
                        displayType={"text"}
                        thousandSeparator={true}
                      />
                    </div>
                  )}
                  {this.state.isLoading && (
                    <ImpulseSpinner
                      size={30}
                      frontColor="var(--gray2)"
                      backColor="var(--gray3)"
                      loading={true}
                    />
                  )}
                </div>

                <div className="profitDetail">
                  <div>سود ریالی</div>
                  <div
                    style={{
                      flex: "1",
                      height: "1px",
                      backgroundColor: "var(--gray3)",
                      margin: "0px 20px",
                    }}
                  />
                  {!this.state.isLoading && (
                    <div
                      style={{ display: "flex", flexDirection: "row-reverse" }}
                    >
                      <NumberFormat
                        allowNegative={true}
                        value={this.state.mwrrValue2}
                        displayType={"text"}
                        thousandSeparator={true}
                      />
                      <div style={{ direction: "rtl", marginRight: "5px" }}>
                        ریال
                      </div>
                    </div>
                  )}
                  {this.state.isLoading && (
                    <ImpulseSpinner
                      size={30}
                      frontColor="var(--gray2)"
                      backColor="var(--gray3)"
                      loading={true}
                    />
                  )}
                </div>

                <div className="profitDetail">
                  <div>سهم سبدگردان</div>
                  {this.props.tabselectedindex !== 0 && (
                    <div style={{ fontSize: "12px" }}>
                      ({this.props.selectedPortfolioPercent}%)&nbsp;
                    </div>
                  )}
                  <div
                    style={{
                      flex: "1",
                      height: "1px",
                      backgroundColor: "var(--gray3)",
                      margin: "0px 20px",
                    }}
                  />
                  {!this.state.isLoading && (
                    <div
                      style={{ display: "flex", flexDirection: "row-reverse" }}
                    >
                      {this.state.mwrrValue3 !== "-" && (
                        <NumberFormat
                          allowNegative={true}
                          value={this.state.mwrrValue3}
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      )}
                      {this.state.mwrrValue3 === "-" && <div>-</div>}
                      {this.state.mwrrValue3 !== "-" && (
                        <div style={{ direction: "rtl", marginRight: "5px" }}>
                          ریال
                        </div>
                      )}
                    </div>
                  )}
                  {this.state.isLoading && (
                    <ImpulseSpinner
                      size={30}
                      frontColor="var(--gray2)"
                      backColor="var(--gray3)"
                      loading={true}
                    />
                  )}
                </div>

                <div className="profitDetail">
                  <div>سهم سرمایه‌گذار</div>
                  {this.props.tabselectedindex !== 0 && (
                    <div style={{ fontSize: "12px" }}>
                      ({100 - this.props.selectedPortfolioPercent}%)&nbsp;
                    </div>
                  )}
                  <div
                    style={{
                      flex: "1",
                      height: "1px",
                      backgroundColor: "var(--gray3)",
                      margin: "0px 20px",
                    }}
                  />
                  {!this.state.isLoading && (
                    <div
                      style={{ display: "flex", flexDirection: "row-reverse" }}
                    >
                      {this.state.mwrrValue4 !== "-" && (
                        <NumberFormat
                          allowNegative={true}
                          value={this.state.mwrrValue4}
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      )}
                      {this.state.mwrrValue4 === "-" && <div>-</div>}
                      {this.state.mwrrValue4 !== "-" && (
                        <div style={{ direction: "rtl", marginRight: "5px" }}>
                          ریال
                        </div>
                      )}
                    </div>
                  )}
                  {this.state.isLoading && (
                    <ImpulseSpinner
                      size={30}
                      frontColor="var(--gray2)"
                      backColor="var(--gray3)"
                      loading={true}
                    />
                  )}
                </div>
              </div>

              <ContextMenuComponent
                data={[{ title: "توضیحات", target: "description" }]}
                isChart={true}
                targett={this.targett1}
                menuClicked={this.menuClicked1.bind(this)}
                ref={this.conmenu1}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
